import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.js";
import { captureInvitationSecretFromBrowser } from "./lib/invitation-secret.js";

// Consume the app invitation that the first head script captured and erased
// before any external request, fallback UI, or application module loaded.
captureInvitationSecretFromBrowser(window);

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in the document.");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
